module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_setouchi-4dca4f3190b90a6aa214c050d53a97fd.png";